module.exports = __webpack_public_path__ + "img/LinkedIn.f113bc70.png";